// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailMeal_meals__nOxSo","meals-appear":"AvailMeal_meals-appear__3a9fr","Loading":"AvailMeal_Loading__YjpBM","mealss":"AvailMeal_mealss__1IU56"};